/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Wizard_Choose_Snapshot_PlaceholderInputs */

const vi_stocktake_wizard_choose_snapshot_placeholder = /** @type {(inputs: Stocktake_Wizard_Choose_Snapshot_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn chốt sổ...`)
};

/**

* @param {Stocktake_Wizard_Choose_Snapshot_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_wizard_choose_snapshot_placeholder = /** @type {((inputs?: Stocktake_Wizard_Choose_Snapshot_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Wizard_Choose_Snapshot_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_wizard_choose_snapshot_placeholder(inputs)
});